import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Logo from '../common/Logo';

const Footer = () => {
  const location = useLocation();
  if (location.pathname.includes('/admin')) return null;

  return (
    <footer className="mt-16 py-12 border-t border-brand-border bg-brand-bg pb-24 md:pb-12">
      <div className="max-w-[1280px] mx-auto px-4 text-center flex flex-col items-center">
        {/* Increased Logo Size */}
        <Logo className="w-16 h-16 mb-6 opacity-90" />
        
        <p className="text-[18px] md:text-[20px] text-brand-secondary leading-[1.55] mb-8 max-w-lg mx-auto">
          Pulse5 is an independent AI news and discovery platform. We strip away the noise so you can see the signal.
        </p>
        
        <div className="flex flex-col items-center gap-6">
          <Link to="/admin/login" className="text-[14px] md:text-[16px] font-mono font-bold text-brand-text bg-brand-surface border border-brand-border hover:border-brand-text/50 hover:bg-brand-raised px-5 py-3 rounded-[6px] uppercase tracking-widest transition-all shadow-sm">
            Editor Login
          </Link>
          <p className="text-[14px] md:text-[16px] text-brand-muted mt-2">
            © {new Date().getFullYear()} Pulse5. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;